import type { RouteRecordRaw } from 'vue-router'
import { languages } from '@/i18n/config'
import AppPage from '@/pages/AppPage.vue'

export function generateRoutes(): RouteRecordRaw[] {
  const routes: RouteRecordRaw[] = []

  for (const lang of Object.values(languages)) {
    const langPrefix = lang.path || `/${lang.code}`

    // Hub route
    if (lang.path === '') {
      // Root language: / is the canonical, /he is an alias
      routes.push({
        path: '/',
        component: AppPage,
        meta: { langCode: lang.code, pageId: 'hub' }
      })
      routes.push({
        path: `/${lang.code}/`,
        component: AppPage,
        meta: { langCode: lang.code, pageId: 'hub' }
      })
    } else {
      routes.push({
        path: `${lang.path}/`,
        component: AppPage,
        meta: { langCode: lang.code, pageId: 'hub' }
      })
    }

    // Spoke routes
    if (lang.spokes) {
      for (const spoke of Object.values(lang.spokes)) {
        routes.push({
          path: `${langPrefix}/${spoke.slug}/`,
          component: AppPage,
          meta: { langCode: lang.code, pageId: spoke.slug }
        })
      }
    }
  }

  return routes
}
